import { createContext, useContext } from 'react';

const WpaCustomerContext = createContext(null);

export function useWpaCustomer() {
  const ctx = useContext(WpaCustomerContext);
  if (!ctx) {
    throw new Error('useWpaCustomer must be used under WpaLayout');
  }
  return ctx;
}

export { WpaCustomerContext };
